import React, { Fragment, useState } from 'react';
import { LocalPopup, ManagedPopup } from 'js/components/common/Popup';
import { WebContent } from 'js/components/system/WebContent';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';
import { useSmartTranslations, useTranslations } from 'js/hooks/i18n';
import style from './index.scss';
import { I18n } from 'js/components/common/I18n';
import { Button } from 'js/components/common/Button';
import { setFraudRequestStatus, setSelfExclusionStatus } from './server';
import { ErrorMessage } from 'js/components/common/ErrorMessage';

const classNames = { inner: style.inner };

export const getAcceptDeclineButtons = ({
    onAcceptClick,
    onDeclineClick,
    acceptBtnText = 'playtech.mobile.system.message.accept',
    declineBtnText = 'playtech.mobile.system.message.decline'
}) => [
    { onClick: onDeclineClick, text: declineBtnText, className: style.btn, color: 'negative' },
    { onClick: onAcceptClick, text: acceptBtnText, className: style.btn }
];

export const getGamblingSuspensionButton = ({
     onDeclineClick,
     declineBtnText = 'playtech.mobile.system.message.gamblingSuspension.cancel'
}) => [
    { onClick: onDeclineClick, text: declineBtnText, className: style.gamblingSuspensionBtn }
];

export const makeConfirmationPopup = WrapperPopup => ({
    title,
    onClose,
    onAccept,
    controls,
    onDecline,
    articleId,
    content = '',
    acceptBtnText,
    declineBtnText,
    isGamblingSuspension,
    ...other
}) => {
    const [error, setError] = useState();
    const [btnState, setDisabledButton] = useState([false]);
    const t = useSmartTranslations();
    const closePopup = useCombinedOnClose(onClose);
    const onAcceptClick = useCombinedHandler([onAccept, closePopup]);
    const onDeclineClick = useCombinedHandler([onDecline, closePopup]);

    const gamblingMessage = 'playtech.mobile.system.gamblingSuspension.message';
    const btnText = 'playtech.mobile.system.message.gamblingSuspension.confirm';
    const translations = useTranslations();

    const buttons = isGamblingSuspension ?
        getGamblingSuspensionButton({ declineBtnText, onDeclineClick }) :
        getAcceptDeclineButtons({ acceptBtnText, declineBtnText, onAcceptClick, onDeclineClick });

    const popupStyle = isGamblingSuspension ? style.gamblingSuspensionPopup : style.popup;

    const onGamblingClick = () => {
        const data = {};
        setDisabledButton([false]);
        data.product = 'system';
        data.period = 'Open ended';

        const sendRequests = async () => {
            await setFraudRequestStatus()
                .then(() => {
                    setSelfExclusionStatus(data)
                        .catch(({ response }) => {
                            const errorCode = response?.data?.errorCode;

                            if (errorCode) {
                                const errorMessage = t(`playtech.mobile.ngresponsiblegaming.self-exclusion.error.${errorCode || 'default'}`);
                                setError(errorMessage);
                            } else {
                                console.error('Error Self-exclusion response');
                            }
                        });
                })
                .catch(() => console.error('Error Check Fraud Event'));
        };

        sendRequests();

    };

    const onGamblingChange = (e) => {
        const thisWord = document.querySelector('#theWord');

        if (thisWord && thisWord.innerHTML === e.target.value) {
            setDisabledButton([true]);
        } else {
            setDisabledButton([false]);
        }
    };

    return (
        <WrapperPopup
            title={title}
            buttons={buttons}
            controls={controls}
            onClose={closePopup}
            classNames={classNames}
            className={popupStyle}
            {...other}
        >
            {isGamblingSuspension ? (
                <Fragment>
                    {error && (
                        <ErrorMessage
                            error={error}
                            animate={true}
                            className={style.error}
                        />
                    )}
                    <div className={style.gamblingSuspensionContainer}>
                        <div className={style.gamblingSuspensionMessage}>
                            {translations(gamblingMessage)}
                        </div>
                        <I18n
                            className={style.gamblingSuspensionWord}
                            tKey={'playtech.mobile.system.gamblingSuspension.word'}
                        />
                        <input
                            id={'confirmSE'}
                            className={style.gamblingSuspensionConfirmWord}
                            placeholder=""
                            type="text"
                            onChange={onGamblingChange}
                        />
                        <Button
                            type="button"
                            disabled={!btnState[0]}
                            onClick={onGamblingClick}
                            className={style.gamblingSuspensionConfirmBtn}
                        >
                            {translations(btnText)}
                        </Button>
                    </div>
                </Fragment>
            ) : (
                <WebContent
                    content={t(content)}
                    id={articleId}
                    className={style.content}
                />
            )}

        </WrapperPopup>
    );
};

export const ManagedConfirmationPopup = makeConfirmationPopup(ManagedPopup);

export const LocalConfirmationPopup = makeConfirmationPopup(LocalPopup);
